import React, { useEffect, useState } from 'react';
import mainImage from '../../../assets/unilever-media/landing-page-girl-1.png';
import Header from '../Header';
import PrivacyPolicy from '../privacyData';
import { useNavigate } from 'react-router-dom';
import { logData } from '../../../Services/APIs/scan';
import { generateRandomAlphaNumeric } from '../../../Utils/alphaNumeric';
const LandingPage = () => {
	const navigate = useNavigate();
	const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
	const isPrivacyAccepted = localStorage.getItem("privacyAccepted");
	const [uid, setUid] = useState('')
	localStorage.setItem("companyBucket", JSON.stringify({ companyBucket: "yves" }));


	useEffect(() => {
		creatUid()
	}, []);

	const creatUid = () => {
		const randomString = generateRandomAlphaNumeric(2);
		const timestamp = Date.now().toString();
		const randomString2 = generateRandomAlphaNumeric(1);
		const unique = randomString + timestamp + randomString2;
		localStorage.setItem("usertpi", JSON.stringify({ usertpi: unique }));
		localStorage.removeItem("isVyesScanCompleted");
		logData({ uid: unique, message: "visited landing page", company: "yves" })
		setUid(unique)
	}

	const handleScanClick = () => {

		if (isPrivacyAccepted) {
			doNavigation()
		}
		else {
			logData({ uid, message: "reading privacy policy", company: "yves" })
			setShowPrivacyPolicy(true);
		}
	};


	const handleAccept = () => {
		localStorage.setItem("privacyAccepted", true);
		doNavigation()
	};

	const doNavigation = () => {
		logData({ uid, message: "accepted privacy policy", company: "yves" })
		navigate("/unilever/usage-instructions");
	}

	const handleClose = () => {
		setShowPrivacyPolicy(false);
	};

	const handleDiscoverClick = () => {
		logData({ uid, message: "clicked on discover the science", company: "yves" })
		window.open("https://www.tanyapepsodent.com/ultra-white/discover-the-science.html", "_self");
	};

	return (
		<div className="bg-gradient-to-t from-[#570103] to-[#9F6D6E] min-h-full flex flex-col items-center text-white font-CirceRounded-Light">
			<Header />
			<div className="flex-grow w-full flex-shrink-0 flex items-center justify-center px-5">
				<img
					src={mainImage}
					alt="main-image"
					className="w-full h-full max-h-[55vh] object-contain"
				/>
			</div>
			<div className="mt-4 space-y-4 p-4 flex flex-col justify-center items-center text-center">
				<h1 className="text-4xl font-CirceRounded-Regular text-[#FDE8EC] md:text-5xl">ShadeScan AI</h1>
				<p className="mt-2 text-lg md:text-2xl">
					Find out how 5 shades whiter teeth looks like on you with Pepsodent Ultra White
				</p>
				<button
					onClick={handleScanClick}
					className="w-full bg-[#D50026] text-white py-3 rounded-full text-lg font-semibold flex items-center justify-center md:text-2xl md:w-1/2"
				>
					Scan your teeth <span className="ml-2">→</span>
				</button>
				<button 
					onClick={handleDiscoverClick}
					className="w-full bg-white text-[#D50026] py-3 mb-2 rounded-full text-lg font-CirceRounded-Regular font-semibold md:text-2xl md:w-1/2"
				>
					Discover the science
				</button>
			</div>
			{showPrivacyPolicy && (
				<PrivacyPolicy onAccept={handleAccept} onClose={handleClose} />
			)}
		</div>
	);
};

export default LandingPage;
